<template>
  <Modal
    v-model="_value"
    width="350"
    title="查看/修改配件信息"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="loginForm" :model="positioningDeviceFitting" :rules="rules" style="display: inline;" :label-width="100">
<!--   主机信息   -->
      <FormItem prop="terminalNum" label="主机号">
        <Input :disabled="true" v-model="positioningDeviceFitting.positioningDeviceInfo==null?null:positioningDeviceFitting.positioningDeviceInfo" placeholder="请输入主机号">
        </Input>
      </FormItem>
        <FormItem prop="simInfos" label="主机芯片码">
          <Input :disabled="true" v-model="positioningDeviceFitting.positioningDeviceInfo==null?null:positioningDeviceFitting.positioningDeviceInfo.encryptionChipNumber" placeholder="请输入主机号">
          </Input>
        </FormItem>
      <FormItem prop="positioningDeviceModelId" label="主机型号">
        <Select :disabled="true" placeholder="主机型号"
                v-model="positioningDeviceFitting.positioningDeviceModelId"
                @on-change="selectPositioningDeviceInfoaisle"
        >
          <Option v-for="(option, index) in positioningDeviceModelOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
        </Select>
      </FormItem>

<!--   配件信息   -->
      <FormItem prop="factoryTerminalNum" label="加密芯片码">
        <Input :disabled="!modify" v-model="positioningDeviceFitting.encryptionChipNumber" placeholder="加密芯片码">
        </Input>
      </FormItem>
      <FormItem prop="positioningDeviceFittingsTypeId" label="设备型号">
        <Select :disabled="!modify" placeholder="选择设备型号"
                v-model="positioningDeviceFitting.positioningDeviceFittingsTypeId"
                @on-change="selectPositioningDeviceFittingInfoaisle"
        >
          <Option v-for="(option, index) in positioningDeviceFittingOptions" :value="option.id" :key="option.id">{{option.name+'('+option.manufacturer+')'}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="sourceType" label="设备来源">
        <Select :disabled="!modify" placeholder="选择设备来源"
                v-model="positioningDeviceFitting.sourceType"
        >
          <Option v-for="(option, index) in positioningDeviceSourceTypeOptions" :value="option.value" :key="option.label">{{option.label}}</Option>
        </Select>
      </FormItem>

      <FormItem prop="installerId" label="安装维修员">
        <Select :disabled="true" class="field" v-model="positioningDeviceFitting.installerId">
          <Option v-for="item in maintainers" :value="item.id" :key="item.realName != null?item.realName:item.nickName != null?item.nickName:item.name">{{item.realName != null?item.realName:item.nickName != null?item.nickName:item.name}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="factoryGuaranteePeriod" label="厂家配件质保期">
        <DatePicker :disabled="true" type="date" v-model="positioningDeviceFitting.factoryGuaranteePeriod"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="clientGuaranteePeriod" label="客户配件质保期">
        <DatePicker :disabled="true" type="date" v-model="positioningDeviceFitting.clientGuaranteePeriod"
                    placeholder="选择日期"></DatePicker>
      </FormItem>
      <FormItem prop="totalAmount" label="金额">
        <InputNumber :disabled="!modify" style="width: 100px;" :min="0" v-model="positioningDeviceFitting.talAmount"
                     placeholder="金额">
        </InputNumber>
      </FormItem>

      <FormItem prop="remark" label="备注">
        <Input type="textarea" :disabled="!modify" v-model="positioningDeviceFitting.remark" placeholder="请输入备注">
        </Input>
      </FormItem>
    </Form>

    <Row style="text-align: right;">
      <Button size="small" style="margin-right: 3px;" @click="onModifyfactoryGuaranteePeriodModal" type="primary">厂家配件质保期</Button>
      <Button size="small" style="margin-right: 3px;" @click="onModifyclientGuaranteePeriodModal" type="primary">客户配件质保期</Button>
      <i-switch v-model="modify" @on-change="modifyChange" size="large">
        <span slot="open">保存</span>
        <span slot="close">修改</span>
      </i-switch>
    </Row>

    <modify-positioning-device-fitting-factory-guarantee-period-modal v-model="ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal" :initValue="ModifyPositioningDeviceFittingFactoryGuaranteePeriodId" @on-success="onSuccess"></modify-positioning-device-fitting-factory-guarantee-period-modal>
    <modify-positioning-device-fitting-client-guarantee-period-modal v-model="ModifyPositioningDeviceFittingClientGuaranteePeriodModal" :initValue="ModifyPositioningDeviceFittingClientGuaranteePeriodId" @on-success="onSuccess"></modify-positioning-device-fitting-client-guarantee-period-modal>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal from '@/view/im/components/modify-positioning-device-fitting-factory-guarantee-period-modal'
import ModifyPositioningDeviceFittingClientGuaranteePeriodModal from '@/view/im/components/modify-positioning-device-fitting-client-guarantee-period-modal'

export default {
  name: 'positioningdevicefittingdetailmodal',
  components: {
    ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal,
    ModifyPositioningDeviceFittingClientGuaranteePeriodModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    factoryTerminalNum: {
      type: Array,
      default: () => {
        return [
          { required: true, message: '芯片码不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  data () {
    return {
      // 多选
      indeterminate: false,
      checkAll: false,
      checkAllGroup: [],

      // 修改厂家配件质保期
      ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal: null,
      ModifyPositioningDeviceFittingFactoryGuaranteePeriodId: null,

      // 修改客户配件质保期
      ModifyPositioningDeviceFittingClientGuaranteePeriodModal: null,
      ModifyPositioningDeviceFittingClientGuaranteePeriodId: null,

      modify: false,
      // 主机类型
      positioningDeviceModelOptions: [],
      // 配件类型
      positioningDeviceFittingOptions: [],
      // 安装维修员
      maintainers: [],

      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],

      positioningDeviceFitting: {
        id: null,
        encryptionChipNumber: null,
        sourceType: null,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          id: null,
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: null,
          positioningDeviceModelId: null,
          sourceType: null,
          remark: null,
          setupDatetime: null,
          serviceDatetime: null,
          encryptionChipNumber: null
        },
        positioningDeviceModelId: null,
        positioningDeviceModel: null,
        positioningDeviceFittingsTypeId: null,
        positioningDevicefittingstype: {

        },
        talAmount: null,
        installerId: null,
        installer: null,
        factoryGuaranteePeriod: null,
        clientGuaranteePeriod: null,
        remark: null
      }
    }
  },
  methods: {
    ...mapActions([
    ]),
    handleCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false
    },
    checkAllGroupChange (data) {
      if (data.length === 10) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
    },

    modifyChange (status) {
      if (status === false) {
        this.$Modal.confirm({
          title: '确认修改配件设备信息',
          content: '<p>确认修改定位设备信息</p>',
          onOk: () => {
            store.dispatch('PositioningDeviceFittingServ_ModifyObj', {
              params: this.positioningDeviceFitting
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
            this.visibleChange(true)
          }
        })
      }
    },
    onSuccess () {
      this.visibleChange(true)
    },
    onPositioningdevicefittings () {
      let queryParams = []
      queryParams.push(genQueryParam('terminalNum', 'EQ', this.positioningDeviceFitting.terminalNum))
      store.dispatch('PositioningDeviceFittingsServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams
        }
      }).then(() => {
        console.log(store.getters.get_PositioningDeviceFittings_GetAllResult)
        this.positioningDeviceFitting.positioningDeviceFittingsId = store.getters.get_PositioningDeviceFittings_GetAllResult[0].id
        store.dispatch('PositioningDeviceInfoServ_BindPositioningDeviceFittings', {
          params: {
            id: this.positioningDeviceFitting.id,
            positioningdevicefittingsid: this.positioningDeviceFitting.positioningDeviceFittingsId
          },
          urlparams: null
        }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    // 厂家配件质保期
    onModifyfactoryGuaranteePeriodModal () {
      this.ModifyPositioningDeviceFittingFactoryGuaranteePeriodModal = true
      this.ModifyPositioningDeviceFittingFactoryGuaranteePeriodId = this.positioningDeviceFitting.id
    },
    // 客户配件质保期
    onModifyclientGuaranteePeriodModal () {
      this.ModifyPositioningDeviceFittingClientGuaranteePeriodModal = true
      this.ModifyPositioningDeviceFittingClientGuaranteePeriodId = this.positioningDeviceFitting.id
    },
    visibleChange (val) {
      if (val) {
        this.modify = false

        this.positioningDeviceFitting.id = null
        this.positioningDeviceFitting.encryptionChipNumber = null
        this.positioningDeviceFitting.sourceType = null
        this.positioningDeviceFitting.positioningDeviceInfoId = null
        this.positioningDeviceFitting.positioningDeviceInfo = null
        this.positioningDeviceFitting.positioningDeviceModelId = null
        this.positioningDeviceFitting.positioningDeviceModel = null
        this.positioningDeviceFitting.positioningDeviceFittingsTypeId = null
        this.positioningDeviceFitting.positioningDevicefittingstype = null
        this.positioningDeviceFitting.talAmount = null
        this.positioningDeviceFitting.installerId = null
        this.positioningDeviceFitting.installer = null
        this.positioningDeviceFitting.factoryGuaranteePeriod = null
        this.positioningDeviceFitting.clientGuaranteePeriod = null
        this.positioningDeviceFitting.remark = null
        this.checkAllGroup = []
        let positioningDeviceFittingId = this._initValue
        if (positioningDeviceFittingId) {
          store.dispatch('PositioningDeviceFittingServ_GetDetail', {
            params: { id: positioningDeviceFittingId }
          }).then(() => {
            this.positioningDeviceFitting = store.getters.get_PositioningDeviceFitting_GetDetailResult
            if (this.positioningDeviceFitting.factoryGuaranteePeriod) {
              this.positioningDeviceFitting.factoryGuaranteePeriod = new Date(this.positioningDeviceFitting.factoryGuaranteePeriod)
            }
            if (this.positioningDeviceFitting.clientGuaranteePeriod) {
              this.positioningDeviceFitting.clientGuaranteePeriod = new Date(this.positioningDeviceFitting.clientGuaranteePeriod)
            }
          }).catch(err => {
            this.$Message.error(err)
          })
        }
        store.dispatch('PositioningDeviceTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          this.positioningDeviceModelOptions = store.getters.get_PositioningDeviceType_GetAllResult
        }).catch(err => {
          console.log(err)
        })

        store.dispatch('PositioningDeviceFittingsTypeServ_GetAll', {
          params: {},
          urlparams: null
        }).then(() => {
          this.positioningDeviceFittingOptions = store.getters.get_PositioningDeviceFittingsType_GetAllResult
        }).catch(err => {
          console.log(err)
        })

        store.dispatch('UserServ_GetAllUsers', {
          params: {},
          urlparams: { roleIds: [8, 14] }
        }).then(() => {
          this.maintainers = store.getters.get_User_GetAllUsersResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    },
    selectPositioningDeviceInfoaisle (data) {
      console.log(data)
      if (data) {
        /**
         * 根据选择类型，默认匹配摄像头搭配
         */
        store.dispatch('PositioningDeviceTypeServ_GetDetail', {
          params: {
            id: data
          },
          urlparams: null
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      }
    },
    selectPositioningDeviceFittingInfoaisle (data) {
      console.log(data)
      if (data) {
        /**
         * 根据选择类型，默认匹配摄像头搭配
         */
        store.dispatch('PositioningDeviceFittingsTypeServ_GetDetail', {
          params: {
            id: data
          },
          urlparams: null
        }).then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        factoryTerminalNum: this.factoryTerminalNum
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
<style>
  .demo-split{
    height: 600px;
    border: 1px solid #dcdee2;
  }
  .demo-split-pane{
    padding: 10px;
  }

  .Checkbox{
    padding: 10px;
  }
</style>
